import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewEncapsulation,
  signal,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { DatePickerModule } from 'primeng/datepicker';
import { FileUploadModule } from 'primeng/fileupload';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { PaginatorModule } from 'primeng/paginator';
import { PopoverModule } from 'primeng/popover';
import { ProgressSpinner } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';

import { environment } from '@environments/environment';
import { TextareaModule } from 'primeng/textarea';

@Component({
  selector: 'rug-module',
  templateUrl: './rug-loader.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    SelectModule,
    RouterModule,
    TableModule,
    InputTextModule,
    FormsModule,
    ChipModule,
    PopoverModule,
    CheckboxModule,
    ToastModule,
    ProgressSpinner,
    SelectButtonModule,
    RadioButtonModule,
    DatePickerModule,
    FormsModule,
    ReactiveFormsModule,
    TagModule,
    InputGroupModule,
    InputGroupAddonModule,
    FileUploadModule,
    MultiSelectModule,
    PaginatorModule,
    AccordionModule,
    TabsModule,
    TextareaModule
  ],
})
export class RugLoaderComponent implements OnInit, OnDestroy {
  private observer: MutationObserver | null = null;
  form: FormGroup;

  value = signal('overview');
  multiselect = null;

  routes: { label: string; value: string }[] = [
    { label: $localize`Overview`, value: 'overview' },
    { label: $localize`Contracts`, value: 'contracts' },
  ];

  constructor(
    private elRef: ElementRef,
    private renderer: Renderer2,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      radiobutton: '',
      selectbutton: '',
      datepicker: '',
    });
  }

  ngOnInit(): void {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${environment.REMOTE_URL_RUG}/styles.css`;
    document.head.appendChild(link);

    const container = this.elRef.nativeElement.querySelector(
      '.rug-loader-container'
    );
    if (!container) return;

    const applyHeight = () => {
      const secondChild = container.children[1];
      if (secondChild) {
        this.renderer.setStyle(secondChild, 'height', '100%');
      }
    };

    applyHeight();

    this.observer = new MutationObserver(() => {
      applyHeight();
    });

    this.observer.observe(container, {
      childList: true,
      subtree: false,
    });
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
